<template>
  <v-card color="#fff" class="rounded-lg mx-auto mt-sm-15" :max-width="$vuetify.breakpoint.smAndUp? 450 : '100%'"
          :height="$vuetify.breakpoint.smAndUp? 'auto' : 'calc( 100vh - 60px)'"
          :flat="$vuetify.breakpoint.xsOnly">
    <v-card-text class="black--text pa-0">
      <div class="text-uppercase text-h6 text-center font-weight-bold pa-5">
        <slot name="title"></slot>
      </div>
      <div class="symbols_wrap">
        <div class="d-flex align-center justify-center links">
          <span class="my_circle">
            <slot name="icon">
              <v-icon class="material-symbols-outlined" x-large color="black">lock</v-icon>
            </slot>
          </span>
        </div>
      </div>
      <div class="font-weight-bold text-h6 text-center pa-3">
        <slot name="errorTitle">

        </slot>
      </div>
    </v-card-text>
    <v-card-text class="black--text px-7 py-5">
      <slot name="errorText">

      </slot>
    </v-card-text>
    <v-card-actions class="py-7">
      <v-row no-gutters justify="center">

        <v-col cols="8">
          <slot name="actions">
          </slot>
        </v-col>
      </v-row>

    </v-card-actions>
    <v-card-text class="text-center black--text font-weight-bold text-body-2 tagline pt-6 mt-4">Powered by Starfish, a WPP Proprietary Platform</v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AccessErrorBase',
};
</script>

<style scoped>

</style>
